import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { PermissionStorageService } from 'src/app/authentication/storages/permission-storage.service';
import { IBaseSearchRequest } from 'src/app/core/models/base';
import { IHoliday } from '../model/holiday';
import { HolidayService } from '../services/holiday.service';

@Injectable({
  providedIn: 'root'
})
export class CurrentDayHolidayResolver  {
  constructor(
    private holidayService: HolidayService,
    private permissionStore: PermissionStorageService
  ){}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IHoliday[]> {

    const permissions = this.permissionStore.getPermissions();
    if (!permissions?.find(p => p === 'Permissions.Holidays.Search')) {
      return of([]);
    }

    let request : IBaseSearchRequest = {
      pageNumber: 0,
      pageSize: 999999,
      advancedFilter: {
        logic: "and",
        filters: [
          {
            field: "start",
            operator: "gte",
            value: new Date(new Date().setUTCHours(0,0,0,0))
          },
          {
            field: "end",
            operator: "lte",
            value: new Date(new Date().setUTCHours(23,59,59,999))
          }
        ]
      }
    }

    return this.holidayService.searchHolidays(request)
    .pipe(
      map(pagedResult => pagedResult.data)
    );
  }
}
